import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
    TapestryButtonModule,
    TapestrySpinnerModule,
    TapestryInlineMessageBoxModule
} from '@predictiveindex/tapestry';
import { DirectivesModule } from '../../core-ui';
import { PageLayoutsModule } from '../../page-layouts';
import { CasePipesModule, TranslationsModule } from '../../translations';
import { InternalActivationsErrorTemplateComponent } from './internal-activations-error-template/internal-activations-error-template.component';
import { InternalActivationsPageComponent } from './InternalActivations.page';
import { InternalActivationsCardComponent } from './InternalActivationsCard.component';
import { InternalActivationsContainerComponent } from './InternalActivationsContainer';

@NgModule({
    declarations: [
        InternalActivationsContainerComponent,
        InternalActivationsPageComponent,
        InternalActivationsCardComponent,
        InternalActivationsErrorTemplateComponent
    ],
    exports: [
        InternalActivationsPageComponent,
        InternalActivationsContainerComponent
    ],
    providers: [],
    imports: [
        CommonModule,
        TapestryButtonModule,
        PageLayoutsModule,
        RouterModule,
        TapestrySpinnerModule,
        TranslationsModule,
        CasePipesModule,
        DirectivesModule,
        TapestryInlineMessageBoxModule
    ]
})
export class InternalActivationsPageModule {}
